export const getPopulatedDocumentsFormData = (
  formValue: Record<string, File | null | boolean>,
) => {
  const formData = new FormData();

  Object.keys(formValue).forEach((key) => {
    let value: File | null | boolean | string =
      formValue[key as keyof typeof formValue];
    if (value === null) return;
    if (typeof value === 'boolean') value = value.toString();

    formData.append(key, value);
  });
  return formData;
};
